<template>
    <div class="mysection">
        <div class="inputs_profile">
          <el-form ref="form" :model="form" :rules="editFormRules">
            <el-row>
                <el-col :span="24">
                  <el-form-item label="原始密码" prop="password" labelWidth="110px">
                    <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                  <el-form-item label="新密码" prop="newPassword" labelWidth="110px">
                    <el-input type="password" v-model="form.newPassword" placeholder="请输入密码"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                  <el-form-item label="新密码确认" prop="confirmNewPassword" labelWidth="110px">
                    <el-input type="password" v-model="form.confirmNewPassword" placeholder="请输入密码"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="btn_large">
            <el-button type="primary" size="large" @click="getPasswordEdit(id)">确定修改</el-button>
        </div>

    </div>
</template>
<script>
    import  {reqWxPassword} from "../../api/weixin-api"
    export default {
        data(){
            return{
                educationArray:[],
                id:'',
                form:{
                    id:'',
                    password:'',
                    newPassword:'',
                    confirmNewPassword:'',
                },
                editFormRules: {
                    password: [
                        {required: true, message: '请输入旧密码', trigger: 'blur'},
                    ],
                    newPassword: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
                            message: '密码由字母和数字组成6到16个字符',
                            trigger: 'blur'
                        },
                    ],
                    confirmNewPassword: [
                        {required: true,message: '请输入确认新密码', trigger: 'blur'},
                    ],
                }
            }
        },
        methods:{
            getPasswordEdit(id){
                var that=this;
              this.$refs.form.validate((valid) => {
                if (valid) {
                  this.form.id=id;
                  let param = Object.assign({}, this.form);
                  reqWxPassword(param).then((res)=>{
                    if(res.data.code==0){
                      that.$message({
                        message: '原密码错误',
                        type: 'error'
                      });
                    }
                    if(res.data.code==1){
                      that.$message({
                        message: '原密码和新密码不能相同',
                        type: 'error'
                      });
                    }
                    if(res.data.code==2){
                      that.$message({
                        message: '两次密码不相同',
                        type: 'error'
                      });

                    }
                    if(res.data.code==4){
                      that.$message({
                        message: '密码修改失败',
                        type: 'error'
                      });
                    }
                    if(res.data.code==3){
                      that.$message({
                        message: '密码修改成功',
                        type: 'success'
                      });
                      window.localStorage.removeItem("Authorization");
                      that.$router.push({path:'/wxLogin'});
                    }
                  })
                }
              })

            },
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          backWeiXin:function() {
            pushHistory();

            function bodyScroll() {
              window.location.href = '/wxMyHomePage';
              window.removeEventListener("popstate", bodyScroll, false);
            }

            window.addEventListener("popstate", bodyScroll, false);

            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          }
        },
        mounted(){
          this.$store.dispatch('hideHF');
           this.isWechatBrowser();
            var id=this.$route.query.id;
            if(id){
              this.id=id;
            }
            this.backWeiXin();
        }
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxMyPassword.vue